import { render, staticRenderFns } from "./BeijingInsPayModal.vue?vue&type=template&id=6b001c7b&scoped=true&"
import script from "./BeijingInsPayModal.vue?vue&type=script&lang=js&"
export * from "./BeijingInsPayModal.vue?vue&type=script&lang=js&"
import style0 from "./BeijingInsPayModal.vue?vue&type=style&index=0&id=6b001c7b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b001c7b",
  null
  
)

export default component.exports